export enum SipTrunkType {
  External = 0,
  ACD = 1,
  IVR = 3,
}
export enum SipTrunkContext {
  External = 'External',
  ACD = 'ACD',
  IVR = 'IVR',
}
export const SipTrunkTypeArray = [
  { id: SipTrunkType.ACD, text: SipTrunkContext.ACD },
  { id: SipTrunkType.IVR, text: SipTrunkContext.IVR },
  { id: SipTrunkType.External, text: SipTrunkContext.External },
];
export class SipTrunkConst {
  static displayColumns = () => {
    return [
      {
        title: 'Cổng kết nối',
        key: 'line',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Kiểu',
        key: 'display_type',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Domain',
        key: 'sipurl',
        display: true,
        allowSort: false,
        classes: '',
      },
    ];
  };
  static displayTypeColumns = type => {
    let html = `<span class="badge badge-default">`;
    switch (type) {
      case SipTrunkType.ACD:
        html += SipTrunkContext.ACD + `</span>`;
        break;
      case SipTrunkType.External:
        html += SipTrunkContext.External + `</span>`;
        break;
      case SipTrunkType.IVR:
        html += SipTrunkContext.IVR + `</span>`;
        break;
    }
    return html;
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/switchboard/siptrunk/siptrunk.const.ts